import React from 'react';
import Chat from '../components/Chat';

const ChatPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <Chat />
    </div>
  );
};

export default ChatPage;
